export const onlyDigits = (value) => String(value || "").replace(/\D/g, "");

export const normalizeIban = (value) => {
  const raw = String(value || "").trim().toUpperCase().replace(/\s/g, "");
  if (!raw) return "";
  if (raw.startsWith("IR")) {
    return `IR${onlyDigits(raw.slice(2))}`;
  }
  const digits = onlyDigits(raw);
  return digits.length === 24 ? `IR${digits}` : digits;
};

export const validateIban = (value) => {
  const normalized = normalizeIban(value);
  if (!normalized) return "شماره شبا الزامی است";
  if (!/^IR\d{24}$/.test(normalized)) {
    return "شماره شبا باید با IR شروع شده و ۲۴ رقم داشته باشد";
  }
  return null;
};

export const validateBankAccount = (value) => {
  const digits = onlyDigits(value);
  if (!digits) return "شماره حساب الزامی است";
  if (digits.length < 6 || digits.length > 20) {
    return "شماره حساب باید بین ۶ تا ۲۰ رقم باشد";
  }
  return null;
};

export const validateCardNumber = (value) => {
  const digits = onlyDigits(value);
  if (!digits) return "شماره کارت الزامی است";
  if (digits.length !== 16) {
    return "شماره کارت باید ۱۶ رقم باشد";
  }
  return null;
};
